import React from "react";
import { Alert, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { CartesianGrid, Line, LineChart, Tooltip, XAxis, YAxis } from "recharts";

import { useAppApi } from "@/App";
import { ExportButton } from "@components/Common/Button";
import { DevForm } from "@components/Forms/Fields";
import { RenderForm } from "@components/Forms/Render";
import { DefaultLayout } from "@components/Layouts";
import { CommonCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function DevelopersReportScreen() {
    return (
        <DefaultLayout>
            <DevelopersReport />
        </DefaultLayout>
    );
}

function DevelopersReport() {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:statements:developers_report"));

    if (!apiData) return;

    const gamesReportUrl = <Link to={url_reverse("statements:games_report")}>Игры</Link>;

    const chartData = [];
    for (const val of Object.values(apiData.report || {})) {
        chartData.push({
            name: val.period,
            uv: val.cnt,
            amt: val.period,
        });
    }

    const buttons = (
        <>
            <DevForm.Button variant="primary" type="submit" name="build">
                {t("Построить")}
            </DevForm.Button>{" "}
            <ExportButton
                prms={{
                    "main-stats_period": apiData.forms_data?.main.data.stats_period,
                    "main-stats_group": apiData.forms_data?.main.data.stats_group,
                    "main-stats_metric": apiData.forms_data?.main.data.stats_metric,
                    "main-excluded_developers": apiData.forms_data?.main.data.excluded_developers,
                }}
            />
        </>
    );

    return (
        <CommonCard header={<div>Разработчики / {gamesReportUrl}</div>}>
            <RenderForm buttons={buttons} />

            {apiData.report?.length === 0 && (
                <Alert variant={"danger"} className="mt-3">
                    {t("Нет данных за этот период")}
                </Alert>
            )}

            {apiData.report?.length > 0 && (
                <>
                    <div className="d-flex align-items-center justify-content-center">
                        <LineChart width={1000} height={300} data={chartData}>
                            <Line type="monotone" dataKey="uv" stroke="#8884d8" />
                            <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />
                        </LineChart>
                    </div>
                    <Table responsive className="dmg-table mt-2">
                        <thead>
                            <tr>
                                <th scope="col">{t("Период")}</th>
                                <th scope="col">{t("Значение метрики")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {apiData.report?.map((obj) => (
                                <tr key={obj.period}>
                                    <td scope="col">{obj.period}</td>
                                    <td scope="col">{obj.cnt}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </>
            )}
        </CommonCard>
    );
}
